import ApiClient from '@/services/api-client';

export default {
  /**
   * Create a new subscription
   *
   * @param plan
   * @returns {Promise}
   */
  create(plan) {
    return ApiClient.post('subscriptions', { plan: plan.id });
  },

  /**
   * Update an existing subscription
   *
   * @param plan
   * @returns {Promise}
   */
  update(plan) {
    return ApiClient.put('subscriptions', { plan: plan.id });
  },

  /**
   * Get last subscription payment id
   *
   * @returns {Promise}
   */
  getLastSubscriptionPaymentId() {
    return ApiClient.get('subscriptions/last-payment-id');
  },

  /**
   * Cancel existing subscription now
   *
   * @returns {Promise}
   */
  cancelNow() {
    return ApiClient.post('subscriptions/cancel-now');
  },
};
